import useEntityVersion from './useEntityVersion';
import { CAMPAIGN_VERSION_POLL_MS } from '../config/polling';

export default function useCampaignVersion() {
  return useEntityVersion({
    endpoint: '/campaign-version',
    queryKeyBase: 'campaign-version',
    pollMs: CAMPAIGN_VERSION_POLL_MS,
  });
}
